import React, { useContext, useState } from "react";
import axios from "axios"
import { StateContext } from "../App";
import './security.css'

function Security() {
    const { state, dispatch } = useContext(StateContext);

    const [error, setError] = useState("")

    const changePassword = async (e) => {
        e.preventDefault();
        setError("")
        
        const normalButton = document.querySelector(".not-loading-btn")
        normalButton.textContent = "processing..."
        normalButton.classList.add("form-button-disabled")


        const form = document.querySelector("#change_password_form")
        const previousPassword = form.oldPassword.value;
        const newPassword = form.newPassword.value;
        const confirmPassword = form.confirmNewPassword.value;

        // account User ID
        const accountId = state.user ? state.user._id : null;
        

        console.log(previousPassword, newPassword, confirmPassword);

        if (newPassword !== confirmPassword) {
            setError("Password does not match!");
            normalButton.textContent = "Change Password"
            normalButton.classList.remove("form-button-disabled")

        } else {
            
            let options = {
                previousPassword,
                newPassword,
                accountId
            }

            try {
                const res = await axios.post('/password-change', options)
                res && console.log('Posting password change Response!===>', res)
                res && console.log('Posting password change Response!2===>', res.data)

                if (res) {
                    normalButton.textContent = "Change Password"
                    
                    form.oldPassword.value = "";
                    form.newPassword.value = "";
                    form.confirmNewPassword.value = "";
                }

                res.data.password && alert(`Congrats! your password has been changed to ( ${newPassword} ) please keep it safe.`)
             } catch (err) {
                console.log('Posting Password change ERR! = ', err);
                normalButton.textContent = "Change Password"
                normalButton.classList.remove("form-button-disabled")
                setError("Unauthorized password incorrect")
            }
        }

    }

    return (
        <div className="Security">
            <h2>Change Password</h2>
            <form id="change_password_form" onSubmit={changePassword}>
                <div className="container">
                    <div className="error"> {error} </div>
                    <div className="input-field">
                        <input type="password" placeholder="Current Password" name="oldPassword" required />
                    </div>
                    <div className="input-field">
                        <input type="password" placeholder="New Password" name="newPassword" required />
                    </div>
                    <div className="input-field">
                        <input type="password" placeholder="Confirm Password" name="confirmNewPassword" required />
                    </div>
                    <button className="not-loading-btn">change password</button>
                    <div className="btn-back">
                        <button disabled className="loading-btn">
                            <div id="loader"></div>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default Security
